import type { ButtonProps } from '@timelyapp/react';
import { Button } from '@timelyapp/react';
import { BorderlessStar } from 'components/Icons';
import React, { forwardRef, useCallback } from 'react';

interface Props extends ButtonProps {
  isFeatureLocked: boolean | undefined;
  onClickLocked: (e: React.SyntheticEvent) => void;
}

const FeatureGatedButton = forwardRef(
  (
    { isFeatureLocked, onClickLocked, onClick, ...props }: Props,
    ref: React.ForwardedRef<HTMLButtonElement>
  ) => {
    const clickHandler = useCallback(
      (e: React.MouseEvent<HTMLButtonElement>) => {
        if (isFeatureLocked) {
          onClickLocked(e);
        } else {
          onClick?.(e);
        }
      },
      [isFeatureLocked, onClick, onClickLocked]
    );
    if (isFeatureLocked) {
      return (
        <Button
          tooltip="This feature is not available. Click to learn more."
          {...props}
          onClick={clickHandler}
          ref={ref}
        >
          <BorderlessStar />
          {typeof props.children === 'string' ? <span>{props.children}</span> : props.children}
        </Button>
      );
    }

    return <Button onClick={clickHandler} {...props} ref={ref} />;
  }
);

export default FeatureGatedButton;
